import { ErrorMessage, Field, Form, FormikProvider, useFormik, FieldArray } from "formik";
import { useEffect, useRef, useState } from "react";
import * as bie from "react-bootstrap";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import { ERROR_MSG, MOBILE_VALIDATION } from "../../CommonUtils/contextVariables";
import { failureAlert, successAlertRefresh } from "../../CommonUtils/SweetAlerts";
import CommonReactTable from "../../CommonUtils/CommonReactTable";
import allowNumbersOnly, { handlePaste } from "../../CommonUtils/CommonValidations";
import { FaDownload } from "react-icons/fa";
import { downloadBase64Pdf } from "../../CommonUtils/ImagesBase64";
import { useSelector } from "react-redux";
import { GetNocServices } from "../../Reducers/AffiliationCommonservice";
import { getServiceFullName } from "../../CommonUtils/CommonValidations";
export default function DegreeUniversityDeficiencyInsp() {
  const NocServicesOptions = useSelector((state) => state?.commonMastersReducer?.nocservices);

  // ********hooks********
  const [clggcmpltedstatus, setclggcmpltedstatus] = useState([]);
  const [filterType, setFilterType] = useState("all");
  const [defInstName, setDefInstName] = useState([]);
  const [defcollcode, setdefcollcode] = useState("");
  const [defshowModal, setDefShowModal] = useState(false);
  const [verificationType, setVerificationType] = useState("");
  const [scrutinyModal, setScrutinyModal] = useState(false);
  const [scrutinydata, setScrutinydata] = useState([]);
  const [teamMembersdata, setTeamMembersdata] = useState([]);
  const [teamStaffsdata, setTeamStaffdata] = useState({});
  const [convData, setConvData] = useState([]);
  const [polyyData, setPolyyData] = useState([]);
  const [assignTeamData, setAssignTeamData] = useState({ online: "", physical: "" });

  const hasFetcheddData = useRef(false);

  //   ********* validation*******
  const defCommitteeValidationSchema = Yup.object().shape({
    nonScrutinyDefModalFields: Yup.array().of(
      Yup.object().shape({
        university: Yup.string().test("university-required-only-second", ERROR_MSG, function (value) {
          const match = this.path.match(/\d+/); // NOSONAR
          const index = match ? Number(match[0]) : -1;
          // Required only for index 1
          if (index === 1) {
            return !!(value && value.trim());
          }
          // Not required for other indexes
          return true;
        }),
        officerName: Yup.string().required(ERROR_MSG),
        designation: Yup.string().required(ERROR_MSG),
        // gmail: Yup.string().email("Invalid email format").required(ERROR_MSG),
        cfmsIdNo: Yup.string().required(ERROR_MSG),
        conClgName: Yup.string().required(ERROR_MSG),
        fromDateInsp: Yup.string().required(ERROR_MSG),
        toDateInsp: Yup.string().required(ERROR_MSG),
        mobileNo: Yup.string().required(ERROR_MSG).matches(MOBILE_VALIDATION, "Invalid mobile number"),
      }),
    ),
  });
  const scrutinyValidationSchema = Yup.object().shape({
    scrutinyTeamm: Yup.string().required("Required"),
  });

  //   *******initial values********
  const degreeUnivFormik = useFormik({
    initialValues: {
      collegeTableData: [],
      nocType: "eop",
      nonScrutinyDefModalFields: Array.from({ length: 3 }, () => ({
        university: "",
        officerName: "",
        designation: "",
        gmail: "",
        cfmsIdNo: "",
        conClgName: "",
        collegeAssigned: "",
        fromDateInsp: "",
        toDateInsp: "",
        mobileNo: "",
      })),
      scrutinyTeamm: "",
    },
    validationSchema: verificationType === "online_scrutiny" ? scrutinyValidationSchema : defCommitteeValidationSchema,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: (values) => {
      handleFinallSubmit(values, defcollcode, verificationType);
    },
  });

  const handleFinallSubmit = (values, defcollCode, verificationTypeParam) => {
    let defteamData = [];
    if (verificationTypeParam === "online_scrutiny") {
      const selectedMember = scrutinydata?.find((item) => item.cfms_id === values.scrutinyTeamm);
      // ✅ scrutiny payload
      defteamData = [
        {
          teamType: "teamHead",
          verificationType: verificationTypeParam,
          officerName: selectedMember?.emp_name ?? "",
          designation: selectedMember?.designation ?? "",
          gmail: selectedMember?.emailid ?? "",
          cfmsIdNo: selectedMember?.cfms_id ?? "",
          collegeAssigned: defInstName ?? "",
          mobileNo: selectedMember?.mobile ?? "",
        },
      ];
    } else {
      // ✅ Committee Payload
      defteamData = values.nonScrutinyDefModalFields
        .map((item, index) => {
          if (!item.officerName) return null;
          return {
            verificationType: verificationTypeParam,
            // ✅ Extra Field Based on Index
            teamType: index === 1 ? "teamHead" : "teamMember",
            officerName: item.officerName ?? "",
            designation: item.designation ?? "",
            gmail: item.gmail ?? "",
            cfmsIdNo: item.cfmsIdNo ?? "",
            conClgName: item.conClgName ?? "",
            collegeAssigned: defInstName ?? "",
            fromDateInsp: item.fromDateInsp ?? "",
            toDateInsp: item.toDateInsp ?? "",
            mobileNo: item.mobileNo ?? "",
          };
        })
        .filter(Boolean);
    }

    // ✅ Final Payload (Common Structure)
    const payload = {
      collCode: Number(defcollCode),
      nocType: values?.nocType,
      defteamData: defteamData,
    };
    Swal.fire({
      text: "Are you sure you want to submit?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel!",
      backdrop: false,
    }).then((result) => {
      if (result.isConfirmed) {
        const url = `${config.url.FAC_URL}saveInspectionAllotementdeficiency`;
        CommonAxiosPost(url, payload)
          .then((res) => {
            if (res?.data?.scode === "01") {
              successAlertRefresh(res?.data?.sdesc);
            } else {
              failureAlert(res?.data?.sdesc);
            }
          })
          .catch((err) => {
            console.log("Submit Error >>>", err);
            failureAlert("Something went wrong");
          });
      }
    });
  };
  function GetInsppData(value) {
    let url = config?.url?.FAC_URL + "deficiencyallotteam/" + value;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        const allotData = (res?.data?.allot || []).map((row, index) => ({
          ...row,
          originalIndex: index,
        }));
        setclggcmpltedstatus(allotData);
        // setclgTable(true);
        // ✅ Map data before setting
        const formattedTableData = allotData.map((row) => ({
          user_id: row.user_id || "",
          coll_code: row.coll_code || "",
          verification_type: row.verification_type || "",
          inst_type: row.inst_type || "",
          inst_name: row.inst_name || "",
          affl_insp_status: row.affl_insp_status || "",
          mobile_email: row.mobile_email || "",
          noc_type: row.noc_type || "",
          // officer_name: row.officer_name || "",
          online_team_data: row.online_team_data || "",
          physical_team_data: row.physical_team_data || "",
        }));
        degreeUnivFormik.setFieldValue("collegeTableData", formattedTableData);
      } else {
        setclggcmpltedstatus([]);
        degreeUnivFormik.setFieldValue("collegeTableData", []);
        // setclgTable(false);
      }
    });
  }
  function GetScrutinyyData() {
    let url = config?.url?.FAC_URL + "getScrutinyCfmsDetails";
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setScrutinydata(res?.data?.data);
      } else {
        setScrutinydata([]);
      }
    });
  }

  function GetTeamMemberssData() {
    let url = config?.url?.FAC_URL + "getTeammembers";
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setTeamMembersdata(res?.data?.data);
      } else {
        setTeamMembersdata([]);
      }
    });
  }

  function GetTeamStaffsDataa(ubCode, index) {
    let url = config?.url?.FAC_URL + "getTeamStaffData?ubCode=" + ubCode;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setTeamStaffdata((prev) => ({
          ...prev,
          [index]: res?.data?.data,
        }));
      } else {
        setTeamStaffdata((prev) => ({
          ...prev,
          [index]: [],
        }));
      }
    });
  }

  function getConvenerrData() {
    let url = config?.url?.FAC_URL + "getConvynordata";
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setConvData(res?.data?.data);
      } else {
        setConvData([]);
      }
    });
  }

  function getPolyyData() {
    let url = config?.url?.FAC_URL + "getpolyprincipaldata";
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setPolyyData(res?.data?.data);
      } else {
        setPolyyData([]);
      }
    });
  }

  useEffect(() => {
    if (!hasFetcheddData.current) {
      GetNocServices();
      GetInsppData("eop");
      hasFetcheddData.current = true;
    }
  }, []);

  async function getProceedingsDetls(defcollCode, noctype) {
    try {
      const res = await CommonAxiosGet(`${config.url.FAC_URL}shiftingallotteampdf/${defcollCode}/${noctype}`);

      if (res?.data?.status !== true) {
        failureAlert("Failed to fetch PDF.");
        return;
      }

      const base64Pdf = res?.data?.file;

      if (!base64Pdf) {
        failureAlert("No PDF data received.");
        return;
      }

      downloadBase64Pdf(base64Pdf, `${defcollCode}_college_Proceedings_report.pdf`);
    } catch (err) {
      console.error("Error fetching PDF:", err);
      failureAlert("Failed to load PDF.");
    }
  }
  const handleSubmitWithTouchh = () => {
    const touchedDefFields = {};

    degreeUnivFormik.values.nonScrutinyDefModalFields.forEach((_, index) => {
      // ✅ Add this — university touched only for index 1
      if (index === 1) {
        touchedDefFields[`nonScrutinyDefModalFields[${index}].university`] = true;
      }
      touchedDefFields[`nonScrutinyDefModalFields[${index}].officerName`] = true;
      touchedDefFields[`nonScrutinyDefModalFields[${index}].designation`] = true;
      touchedDefFields[`nonScrutinyDefModalFields[${index}].gmail`] = true;
      touchedDefFields[`nonScrutinyDefModalFields[${index}].cfmsIdNo`] = true;
      touchedDefFields[`nonScrutinyDefModalFields[${index}].conClgName`] = true;
      touchedDefFields[`nonScrutinyDefModalFields[${index}].collegeAssigned`] = true;
      touchedDefFields[`nonScrutinyDefModalFields[${index}].fromDateInsp`] = true;
      touchedDefFields[`nonScrutinyDefModalFields[${index}].toDateInsp`] = true;
      touchedDefFields[`nonScrutinyDefModalFields[${index}].mobileNo`] = true;
    });
    degreeUnivFormik.setTouched(touchedDefFields, true);
    degreeUnivFormik.submitForm();
  };

  const handleOfficerChange = (index, selectedCfms) => {
    // find selected officer
    const selectedFaculty = (teamStaffsdata[index] || []).find((item) => item.fac_name === selectedCfms);
    // set officer name
    degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[${index}].officerName`, selectedCfms);
    if (selectedFaculty) {
      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[${index}].gmail`, selectedFaculty.email_id || "");
      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[${index}].cfmsIdNo`, selectedFaculty.cfms_id || "");
      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[${index}].mobileNo`, selectedFaculty.contact || "");
      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[${index}].conClgName`, selectedFaculty.univ_name || "");
      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[${index}].designation`, selectedFaculty.designation || "");
    }
  };

  // Find selected employee for Scrutiny
  const selectedScrutinyMember = scrutinydata?.find((item) => item.cfms_id === degreeUnivFormik.values.scrutinyTeamm);
  const iconButton = {
    border: "none",
    padding: "6px 10px",
    borderRadius: "6px",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  };
  const downloadBtn = {
    ...iconButton,
    backgroundColor: "#e6f9f0",
    color: "#059669",
  };
  // ****** reset formik data for modal popup*****
  const resetCommitteeFields = () => {
    degreeUnivFormik.setFieldValue(
      "nonScrutinyDefModalFields",
      Array.from({ length: 3 }, () => ({
        university: "",
        officerName: "",
        designation: "",
        gmail: "",
        cfmsIdNo: "",
        conClgName: "",
        collegeAssigned: "",
        fromDateInsp: "",
        toDateInsp: "",
        mobileNo: "",
      })),
    );
    degreeUnivFormik.setFieldValue("scrutinyTeamm", "");
  };

  const handleClose = () => setDefShowModal(false);
  const handleScrutinyClose = () => setScrutinyModal(false);

  const ColumnsData = [
    {
      id: "slNo",
      header: "Sl.No",
      cell: ({ row }) => row.index + 1,
    },
    {
      id: "coll_code",
      header: "College Code",
      accessorKey: "coll_code",
      meta: { style: { textAlign: "center" } },
    },
    {
      id: "inst_name",
      header: "College Name",
      accessorKey: "inst_name",
      cell: ({ row }) => <div style={{ textAlign: "left" }}>{row.original.inst_name}</div>,
    },

    {
      id: "mobile_email",
      header: "Contact Details",
      accessorKey: "mobile_email",
      cell: ({ row }) => <div style={{ textAlign: "left" }}>{row.original.mobile_email}</div>,
    },

    {
      id: "user_id",
      header: "Inspection User Id",
      accessorKey: "user_id",
      meta: { style: { textAlign: "center" } },
    },
    // {
    //   id: "noc_type",
    //   header: "NOC Type",
    //   accessorKey: "noc_type",
    //   meta: { style: { textAlign: "center" } },
    // },

    {
      id: "verificationType",
      header: "Verification Type",
      cell: ({ row }) => {
        const index = row.original.originalIndex;
        const nocType = row?.original?.noc_type;

        const isShifting = nocType === "shifting";

        return (
          <div style={{ minWidth: "200px" }}>
            <Field as="select" name={`collegeTableData[${index}].verification_type`} className="form-control">
              <option value="">---select---</option>
              <option value="online_scrutiny">Online Scrutiny</option>
              {isShifting && (
                <>
                  <option value="physical_committee">Physical Committee</option>
                  <option value="virtual_committee">Virtual Committee</option>
                </>
              )}
            </Field>
          </div>
        );
      },
    },
    {
      id: "already_online_team_data",
      header: "Already Assigned Team Member",
      accessorKey: "already_online_team_data",
      meta: { style: { textAlign: "left" } },
    },

    {
      id: "online_team_data",
      header: "Assigned Team Member-Online Scrutiny",
      accessorKey: "online_team_data",
      meta: { style: { textAlign: "center" } },
    },



    // {
    //   id: "physical_team_data",
    //   header: "Assigned Team Member-Physical Committee",
    //   accessorKey: "physical_team_data",
    //   meta: { style: { textAlign: "center" } },

    //   cell: ({ row }) => {
    //     const index = row.original.originalIndex;

    //     const isShifting =
    //       row.original.noc_type?.toLowerCase() === "shifting";

    //     // get latest formik value
    //     const verificationType =
    //       degreeUnivFormik?.collegeTableData?.[index]?.verification_type;

    //     console.log("Row Original :", row.original);
    //     console.log("Index :", index);
    //     console.log("Is Shifting :", isShifting);
    //     console.log("Verification Type :", verificationType);
    //     console.log(
    //       "Button Visible :",
    //       isShifting && verificationType === "physical_committee"
    //     );

    //     return (
    //       <div
    //         style={{
    //           display: "flex",
    //           gap: "8px",
    //           justifyContent: "center",
    //           alignItems: "center",
    //         }}
    //       >
    //         <span>{row.original.physical_team_data || "-"}</span>

    //         {isShifting &&
    //           verificationType === "physical_committee" && (
    //             <button
    //               style={downloadBtn}
    //               onClick={async () => {
    //                 console.log("Download Clicked");

    //                 getProceedingsDetls(
    //                   row.original.coll_code,
    //                   row?.original?.noc_type
    //                 );
    //               }}
    //               title="Download Report"
    //             >
    //               <FaDownload />
    //             </button>
    //           )}
    //       </div>
    //     );
    //   },
    // },

    {
      id: "actions",
      header: "Mapping for Reset Password",
      cell: ({ row }) => {
        // ✅ Define here (outside onClick)
        const rowVerificationType = degreeUnivFormik?.values?.collegeTableData[row.original.originalIndex]?.verification_type || "";

        return (
          <div>
            <button
              type="button"
              className="btn btn-success btn-sm float-end rounded mb-2"
              onClick={() => {
                if (!rowVerificationType) {
                  Swal.fire({
                    icon: "warning",
                    title: "Please select Verification Type",
                  });
                  return;
                }
                resetCommitteeFields();

                // Save already assigned team data to filter from dropdowns on reassign
                setAssignTeamData({
                  online: row.original.online_team_data || "",
                  physical: row.original.physical_team_data || "",
                });

                // Save selected row data
                setdefcollcode(row.original.coll_code);
                setVerificationType(rowVerificationType);

                if (rowVerificationType === "online_scrutiny") {
                  setScrutinyModal(true);
                  GetScrutinyyData();
                } else {
                  setDefShowModal(true);
                  GetTeamMemberssData();
                  getConvenerrData();
                  getPolyyData();
                }
                setDefInstName(row.original.inst_name);
              }}
            >
              {rowVerificationType === "" ? "Assign Team" : "Re-Assign Team"}
            </button>
          </div>
        );
      },
    },
  ];

  const filteredDefData = clggcmpltedstatus.filter((item) => {
    // Check if at least one team member is assigned (online OR physical)
    const hasOnlineTeam = item.online_team_data && item.online_team_data.trim() !== "";
    const hasPhysicalTeam = item.physical_team_data && item.physical_team_data.trim() !== "";
    const isTeamAssigned = hasOnlineTeam || hasPhysicalTeam;

    if (filterType === "assign") return !isTeamAssigned; // Team NOT allotted
    if (filterType === "reassign") return isTeamAssigned; // Team allotted
    return true;
  });

  const assignCount = clggcmpltedstatus.filter((item) => {
    const hasOnlineTeam = item.online_team_data && item.online_team_data.trim() !== "";
    const hasPhysicalTeam = item.physical_team_data && item.physical_team_data.trim() !== "";
    return !(hasOnlineTeam || hasPhysicalTeam);
  }).length;

  const reassignCount = clggcmpltedstatus.filter((item) => {
    const hasOnlineTeam = item.online_team_data && item.online_team_data.trim() !== "";
    const hasPhysicalTeam = item.physical_team_data && item.physical_team_data.trim() !== "";
    return hasOnlineTeam || hasPhysicalTeam;
  }).length;
  return (
    <>
      <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
        <FormikProvider value={degreeUnivFormik}>
          <Form onSubmit={degreeUnivFormik.handleSubmit} onChange={degreeUnivFormik.handleChange} className="affl-form">
            <bie.Row className="px-2 pt-3 mb-3 w-100">
              <h5 className="mb-3 innerheader-new">
                <span>Deficiency Allot Team Member Report</span>
              </h5>
              <bie.Row>
                <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                  <label
                    className="form-label mb-0"
                    style={{
                      color: "#0f766e",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      marginBottom: 0,
                    }}
                  >
                    Select NOC Type
                  </label>
                  <Field
                    as="select"
                    name="nocType"
                    className="form-control"
                    onChange={(e) => {
                      const value = e.target.value;
                      degreeUnivFormik.setFieldValue("nocType", value);
                      // setclgTable(false);
                      GetInsppData(value);
                    }}
                  >
                    <option value="">--select--</option>
                    {/* <option value="eop">EOP</option>
                    <option value="new_college">New College</option>
                    <option value="management">Management Change</option>
                    <option value="shifting">Shifting</option> */}

                    {NocServicesOptions
                      ?.filter((service) => service.is_active)
                      .map((service) => (
                        <option
                          key={service.nos_short_name}
                          value={service.nos_short_name}
                        >
                          {service.full_name}
                        </option>
                      ))}
                  </Field>
                </bie.Col>
              </bie.Row>
              {clggcmpltedstatus?.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    gap: "15px",
                    marginTop: "20px",
                    marginBottom: "20px",
                    borderBottom: "2px solid #ddd",
                    paddingBottom: "10px",
                  }}
                >
                  <div
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        setFilterType("all");
                      }
                    }}
                    onClick={() => setFilterType("all")}
                    style={{
                      cursor: "pointer",
                      padding: "8px 16px",
                      borderRadius: "6px",
                      backgroundColor: filterType === "all" ? "#4f46e5" : "#f1f1f1",
                      color: filterType === "all" ? "#fff" : "#000",
                      fontWeight: "bold",
                    }}
                  >
                    📋 All ({clggcmpltedstatus.length})
                  </div>

                  <div
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        setFilterType("assign");
                      }
                    }}
                    onClick={() => setFilterType("assign")}
                    style={{
                      cursor: "pointer",
                      padding: "8px 16px",
                      borderRadius: "6px",
                      backgroundColor: filterType === "assign" ? "#dc3545" : "#f1f1f1",
                      color: filterType === "assign" ? "#fff" : "#000",
                      fontWeight: "bold",
                    }}
                  >
                    🔁 Team Not Allotted ({assignCount})
                  </div>

                  <div
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        setFilterType("reassign");
                      }
                    }}
                    onClick={() => setFilterType("reassign")}
                    style={{
                      cursor: "pointer",
                      padding: "8px 16px",
                      borderRadius: "6px",
                      backgroundColor: filterType === "reassign" ? "#168a43" : "#f1f1f1",
                      color: filterType === "reassign" ? "#fff" : "#000",
                      fontWeight: "bold",
                    }}
                  >
                    👥 Team Allotted ({reassignCount})
                  </div>
                </div>
              )}
              {filteredDefData?.length > 0 ? (
                <>
                  <div className="table-responsive">
                    <CommonReactTable
                      data={filteredDefData}
                      columns={ColumnsData}
                      filename="University Assign Inspection"

                      headerName={`Deficiency Allot Team Member Report - ${getServiceFullName(
                        degreeUnivFormik?.values?.nocType,
                        NocServicesOptions
                      )}`}


                      showFooter={false}
                      showPagination={false}
                      showExcel={true}
                      showPrint={false}
                      excelFileName="University Assign Inspection"
                    />
                  </div>
                </>
              ) : (
                <center className="text-danger h6">*** No Data Found ***</center>
              )}

              <bie.Modal show={defshowModal} onHide={handleClose} size="xl" dialogClassName="custom-modal-width">
                <bie.Modal.Header closeButton style={{ backgroundColor: "#bbc2e9" }}>
                  <bie.Modal.Title>Assigning Inspection Team to {defInstName} College</bie.Modal.Title>
                </bie.Modal.Header>

                <bie.Modal.Body style={{ overflowX: "auto" }}>
                  <FieldArray name="nonScrutinyDefModalFields">
                    {() => (
                      <div style={{ overflowX: "auto" }}>
                        {/* ***********Committee Convenor Details********** */}
                        <h5 className="mb-3 innerheader-new">
                          <span>Committee Convenor Details</span>
                        </h5>
                        <table table className="table table-bordered mt-2 ">
                          <thead className="table-primary">
                            <tr>
                              <th style={{ width: "180px" }}>University</th>
                              <th style={{ width: "180px" }}>Convenor Name</th>
                              <th style={{ width: "140px" }}>Designation</th>
                              <th style={{ width: "150px" }}>Contact No</th>
                              <th style={{ width: "200px" }}>Email Id</th>
                              <th style={{ width: "160px" }}>CFMS id/Emp id</th>
                              <th style={{ width: "160px" }}>Convenor College Name</th>
                              <th style={{ width: "180px" }}>College Assigned</th>
                              <th style={{ width: "140px" }}>From Date</th>
                              <th style={{ width: "140px" }}>To Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {[1].map((index) => (
                              <tr key={index}>
                                {/* University */}

                                <td>
                                  <Field
                                    as="select"
                                    name={`nonScrutinyDefModalFields[${index}].university`}
                                    className="form-control"
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[${index}].university`, value);
                                      // Clear row fields
                                      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[${index}].officerName`, "");
                                      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[${index}].designation`, "");
                                      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[${index}].gmail`, "");
                                      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[${index}].cfmsIdNo`, "");
                                      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[${index}].mobileNo`, "");
                                      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[${index}].conClgName`, "");
                                      // Load officers row-wise
                                      GetTeamStaffsDataa(value, index);
                                    }}
                                  >
                                    <option value="">Select University</option>
                                    {teamMembersdata && teamMembersdata.length > 0 ? (
                                      teamMembersdata.map((item, idx) => (
                                        <option key={idx} value={item.ub_code}>
                                          {item.univ_name}
                                        </option>
                                      ))
                                    ) : (
                                      <option value="">No Data Available</option>
                                    )}
                                  </Field>
                                  <ErrorMessage name={`nonScrutinyDefModalFields[${index}].university`} component="div" className="text-danger" />
                                </td>

                                {/* Officer Name */}
                                <td>
                                  <Field
                                    as="select"
                                    name={`nonScrutinyDefModalFields[${index}].officerName`}
                                    className="form-control"
                                    disabled={!degreeUnivFormik.values.nonScrutinyDefModalFields[index]?.university}
                                    onChange={(e) => {
                                      handleOfficerChange(index, e.target.value);
                                    }}
                                  >
                                    <option value="">Select Officer</option>

                                    {(teamStaffsdata[index] || []).length > 0 ? (
                                      (teamStaffsdata[index] || [])
                                        .filter((item) => !assignTeamData.physical?.includes(item.fac_name))
                                        .map((item, idx) => (
                                          <option key={idx} value={item.fac_name}>
                                            {item.fac_name}
                                          </option>
                                        ))
                                    ) : (
                                      <option value="">No Staff Available</option>
                                    )}
                                  </Field>
                                  <ErrorMessage name={`nonScrutinyDefModalFields[${index}].officerName`} component="div" className="text-danger" />
                                </td>

                                {/* Designation */}

                                <td>
                                  <Field name={`nonScrutinyDefModalFields[${index}].designation`} className="form-control" disabled />
                                  <ErrorMessage name={`nonScrutinyDefModalFields[${index}].designation`} component="div" className="text-danger" />
                                </td>

                                {/* Mobile */}

                                <td>
                                  <Field name={`nonScrutinyDefModalFields[${index}].mobileNo`} className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} onPaste={handlePaste} disabled />
                                  <ErrorMessage name={`nonScrutinyDefModalFields[${index}].mobileNo`} component="div" className="text-danger" />
                                </td>

                                {/* Email */}

                                <td>
                                  <Field name={`nonScrutinyDefModalFields[${index}].gmail`} className="form-control" disabled />
                                  <ErrorMessage name={`nonScrutinyDefModalFields[${index}].gmail`} component="div" className="text-danger" />
                                </td>

                                {/* CFMS */}

                                <td>
                                  <Field name={`nonScrutinyDefModalFields[${index}].cfmsIdNo`} className="form-control" disabled />
                                  <ErrorMessage name={`nonScrutinyDefModalFields[${index}].cfmsIdNo`} component="div" className="text-danger" />
                                </td>

                                {/* Convenor College */}

                                <td>
                                  <Field name={`nonScrutinyDefModalFields[${index}].conClgName`} className="form-control" disabled />
                                  <ErrorMessage name={`nonScrutinyDefModalFields[${index}].conClgName`} component="div" className="text-danger" />
                                </td>

                                {/* College Assigned */}

                                <td>
                                  <input value={defInstName} disabled className="form-control" />

                                  <Field type="hidden" name={`nonScrutinyDefModalFields[${index}].collegeAssigned`} value={defInstName} />
                                </td>

                                {/* From Date */}

                                <td>
                                  <Field
                                    type="date"
                                    name={`nonScrutinyDefModalFields[${index}].fromDateInsp`}
                                    className="form-control"
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      // update index 1
                                      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[index].fromDateInsp`, value);
                                      // copy to index 0 & 2
                                      [0, 2].forEach((i) => {
                                        degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[${i}].fromDateInsp`, value);
                                      });
                                    }}
                                  />
                                  <ErrorMessage name={`nonScrutinyDefModalFields[${index}].fromDateInsp`} component="div" className="text-danger" />
                                </td>

                                {/* To Date */}

                                <td>
                                  <Field
                                    type="date"
                                    name={`nonScrutinyDefModalFields[${index}].toDateInsp`}
                                    className="form-control"
                                    min={degreeUnivFormik.values.nonScrutinyDefModalFields[index]?.fromDateInsp || ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      // update index 1
                                      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[index].toDateInsp`, value);
                                      // copy to index 0 & 2
                                      [0, 2].forEach((i) => {
                                        degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[${i}].toDateInsp`, value);
                                      });
                                    }}
                                  />
                                  <ErrorMessage name={`nonScrutinyDefModalFields[${index}].toDateInsp`} component="div" className="text-danger" />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {/* **************Team Member Details*********** */}
                        <h5 className="mb-3 innerheader-new">
                          <span>Team Member Details</span>
                        </h5>

                        <table className="table table-bordered mt-2">
                          <thead className="table-primary">
                            <tr>
                              <th>Convenor Details</th>
                              <th>Designation</th>
                              <th>Contact No</th>
                              <th>Email Id</th>
                              <th>CFMS id/Emp id</th>
                              <th>Convenor College Name</th>
                              <th>College Assigned</th>
                              <th>From Date</th>
                              <th>To Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              {/* Team Head */}
                              <td>
                                <Field
                                  as="select"
                                  name={`nonScrutinyDefModalFields[0].officerName`}
                                  className="form-control"
                                  onChange={(e) => {
                                    const selectedName = e.target.value;

                                    // Set selected officer name
                                    degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[0].officerName`, selectedName);

                                    // Find selected row
                                    const selectedRow = convData.find((item) => item.principal_name === selectedName);

                                    // Set remaining fields
                                    if (selectedRow) {
                                      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[0].designation`, selectedRow.designation || "-");
                                      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[0].gmail`, selectedRow.email || "");
                                      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[0].mobileNo`, selectedRow.mobile || "");
                                      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[0].conClgName`, selectedRow.coll_name || "");
                                      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[0].cfmsIdNo`, selectedRow.cfms_id || "-");
                                    }
                                  }}
                                >
                                  <option value="">Select Convenor</option>

                                  {convData && convData.length > 0 ? (
                                    convData
                                      .filter((item) => !assignTeamData.physical?.includes(item.principal_name))
                                      .map((item, idx) => (
                                        <option key={idx} value={item.principal_name}>
                                          {item.principal_name}-{item.short_name_college}
                                        </option>
                                      ))
                                  ) : (
                                    <option value="">No Data Available</option>
                                  )}
                                </Field>

                                <ErrorMessage name={`nonScrutinyDefModalFields[0].officerName`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field name={`nonScrutinyDefModalFields[0].designation`} className="form-control" disabled />
                                <ErrorMessage name={`nonScrutinyDefModalFields[0].designation`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field name={`nonScrutinyDefModalFields[0].mobileNo`} className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} onPaste={handlePaste} disabled />
                                <ErrorMessage name={`nonScrutinyDefModalFields[0].mobileNo`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field name={`nonScrutinyDefModalFields[0].gmail`} className="form-control" disabled />
                                <ErrorMessage name={`nonScrutinyDefModalFields[0].gmail`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field name={`nonScrutinyDefModalFields[0].cfmsIdNo`} className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} onPaste={handlePaste} />
                                <ErrorMessage name={`nonScrutinyDefModalFields[0].cfmsIdNo`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field name={`nonScrutinyDefModalFields[0].conClgName`} className="form-control" onPaste={handlePaste} disabled />
                                <ErrorMessage name={`nonScrutinyDefModalFields[0].conClgName`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <input value={defInstName} disabled className="form-control" />
                                <Field type="hidden" name={`nonScrutinyDefModalFields[0].collegeAssigned`} value={defInstName} />
                              </td>

                              <td>
                                <Field type="date" name={`nonScrutinyDefModalFields[0].fromDateInsp`} className="form-control" disabled />
                                <ErrorMessage name={`nonScrutinyDefModalFields[0].fromDateInsp`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field type="date" name={`nonScrutinyDefModalFields[0].toDateInsp`} className="form-control" disabled />
                                <ErrorMessage name={`nonScrutinyDefModalFields[0].toDateInsp`} component="div" className="text-danger" />
                              </td>
                            </tr>

                            <tr>
                              {/* Team Head */}
                              <td>
                                <Field
                                  as="select"
                                  name={`nonScrutinyDefModalFields[2].officerName`}
                                  className="form-control"
                                  onChange={(e) => {
                                    const selectedName = e.target.value;

                                    // Set selected officer name
                                    degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[2].officerName`, selectedName);

                                    // Find selected row
                                    const selectedRow = polyyData.find((item) => item.principal_name === selectedName);

                                    // Set remaining fields
                                    if (selectedRow) {
                                      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[2].designation`, selectedRow.designation || "-");
                                      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[2].gmail`, selectedRow.email_id || "");
                                      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[2].mobileNo`, selectedRow.mobile || "");
                                      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[2].conClgName`, selectedRow.inst_name || "");
                                      degreeUnivFormik.setFieldValue(`nonScrutinyDefModalFields[2].cfmsIdNo`, selectedRow.cfms_id || "-");
                                    }
                                  }}
                                >
                                  <option value="">Select Convenor</option>

                                  {polyyData && polyyData?.length > 0 ? (
                                    polyyData?.filter((item) => !assignTeamData.physical?.includes(item.principal_name))
                                      .map((item, idx) => (
                                        <option key={idx} value={item.principal_name}>
                                          {item.principal_name}
                                          {/* -{item.short_name_college} */}
                                        </option>
                                      ))
                                  ) : (
                                    <option value="">No Data Available</option>
                                  )}
                                </Field>

                                <ErrorMessage name={`nonScrutinyDefModalFields[2].officerName`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field name={`nonScrutinyDefModalFields[2].designation`} className="form-control" disabled />
                                <ErrorMessage name={`nonScrutinyDefModalFields[2].designation`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field name={`nonScrutinyDefModalFields[2].mobileNo`} className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} onPaste={handlePaste} disabled />
                                <ErrorMessage name={`nonScrutinyDefModalFields[2].mobileNo`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field name={`nonScrutinyDefModalFields[2].gmail`} className="form-control" disabled />
                                <ErrorMessage name={`nonScrutinyDefModalFields[2].gmail`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field name={`nonScrutinyDefModalFields[2].cfmsIdNo`} className="form-control" maxLength={10} onKeyPress={allowNumbersOnly} onPaste={handlePaste} />
                                <ErrorMessage name={`nonScrutinyDefModalFields[2].cfmsIdNo`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field name={`nonScrutinyDefModalFields[2].conClgName`} className="form-control" disabled />
                                <ErrorMessage name={`nonScrutinyDefModalFields[2].conClgName`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <input value={defInstName} disabled className="form-control" />
                                <Field type="hidden" name={`nonScrutinyDefModalFields[2].collegeAssigned`} value={defInstName} />
                                <ErrorMessage name={`nonScrutinyDefModalFields[2].collegeAssigned`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field type="date" name={`nonScrutinyDefModalFields[2].fromDateInsp`} className="form-control" disabled />
                                <ErrorMessage name={`nonScrutinyDefModalFields[2].fromDateInsp`} component="div" className="text-danger" />
                              </td>

                              <td>
                                <Field type="date" name={`nonScrutinyDefModalFields[2].toDateInsp`} className="form-control" disabled />
                                <ErrorMessage name={`nonScrutinyDefModalFields[2].toDateInsp`} component="div" className="text-danger" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    )}
                  </FieldArray>

                  <div className="d-flex justify-content-end mt-3">
                    <bie.Button type="submit" variant="success" onClick={handleSubmitWithTouchh}>
                      Save Data
                    </bie.Button>
                  </div>
                </bie.Modal.Body>
              </bie.Modal>

              {/* ********** Scrutiny Modal Popup******** */}
              <bie.Modal show={scrutinyModal} onHide={handleScrutinyClose} size="xl">
                <bie.Modal.Header closeButton style={{ backgroundColor: "#bbc2e9" }}>
                  <bie.Modal.Title>Assigning Inspection Team to {defInstName} College</bie.Modal.Title>
                </bie.Modal.Header>
                <bie.Modal.Body>
                  <bie.Row>
                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                      <label className="field-mandatory">
                        {" "}
                        <b>Online Scrutiny Team</b>
                      </label>
                      <Field as="select" name="scrutinyTeamm" className="form-control">
                        <option value="">-- Select Scrutiny Team --</option>
                        {scrutinydata
                          ?.filter((item) => !assignTeamData.online?.includes(item.emp_name) && !assignTeamData.online?.includes(item.cfms_id))
                          .map((item) => (
                            <option key={item.cfms_id} value={item.cfms_id}>
                              {item.emp_name} - {item.cfms_id}
                            </option>
                          ))}
                      </Field>
                      <ErrorMessage name="scrutinyTeamm" component="div" className="text-danger" />
                    </bie.Col>
                  </bie.Row>

                  {/* Table */}
                  {selectedScrutinyMember && (
                    <bie.Row className="mt-3">
                      <bie.Col xs={12}>
                        <div className="table-responsive">
                          <table className="table table-bordered w-100">
                            <thead className="table-primary text-center">
                              <tr>
                                <th>CFMS ID</th>
                                <th>Employee Name</th>
                                <th>Designation</th>
                                <th>Mobile No</th>
                                <th>Email ID</th>
                                <th>Assigned College</th>
                              </tr>
                            </thead>
                            <tbody className="text-center">
                              <tr>
                                <td>{selectedScrutinyMember.cfms_id}</td>
                                <td>{selectedScrutinyMember.emp_name}</td>
                                <td>{selectedScrutinyMember.designation}</td>
                                <td>{selectedScrutinyMember.mobile}</td>
                                <td>{selectedScrutinyMember.emailid}</td>
                                <td>{defInstName}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </bie.Col>
                    </bie.Row>
                  )}
                  <div className="d-flex justify-content-end mt-3">
                    <bie.Button type="submit" variant="success" onClick={handleSubmitWithTouchh}>
                      Save Data
                    </bie.Button>
                  </div>
                </bie.Modal.Body>
              </bie.Modal>
            </bie.Row>
          </Form>
        </FormikProvider>
      </bie.Container>
    </>
  );
}
